/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState } from "react";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { appConstants } from "Front/_constants/app.constants.js";
import { debounce } from "lodash";

const DrugFilterModal = ({ showModal, handleClose, filters }) => {
    const [isDrugExist, setIsDrugExist] = useState(false);
    const [isSpecialCharacter, setIsSpecialCharacter] = useState(false);
    const [searchLength, setSearchLength] = useState(false);
    const [selectedDrugs, setSelectedDrugs] = useState(filters || [])
    const [options, setOptions] = useState([]);
    const CancelToken = axios.CancelToken;
    let cancel;
    let drugSearchData = "";


    const drugSearch = debounce(async (e) => {
        if (cancel) {
            cancel(); // Cancel the previous API request
        }
        if (isDrugExist)
            setIsDrugExist(false);
        setIsSpecialCharacter(false);
        //setIsSearchBoxOpen(true);
        let search = "";
        if (e.length >= 100) {
            setSearchLength(true);
            return;
        } else {
            setSearchLength(false);
            search = e.replace(/\s+/g, " ");
            drugSearchData = search;
            // document.getElementById("txtsearchdrug").value =
            //   drugSearchData.trimStart();
        }
        let sessionToken = localStorage.getItem("token");
        let flag = "brand";
        if (search !== "") {
            // if (!/[^a-zA-Z0-9  .]/.test(search)) {
            let strUrl = appConstants.paAppURL;
            strUrl += "drugSearch";


            axios
                .post(
                    strUrl,
                    { search: search, flag: flag },
                    {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        }),
                        headers: {
                            Authorization: sessionToken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((response) => {
                    if (search === drugSearchData) {
                        const formattedOptions = response.data.drugData.map((item) => ({
                            value: item?._id,
                            label: item?.drugNameWithDose,
                        }));
                        setOptions([...formattedOptions]);
                    }
                    if (response.data.drugData.length === 0) {
                        setOptions([])
                    }
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {

                    }
                });

            // } else {
            //   setIsSpecialCharacter(true)
            // }
        } else {
            setOptions([])
            // closeLists();
        }
    }, 300)

    const handleSelectChange = (selected) => {
        console.log(selected, "-----selected")
        const alreadyAdded = selectedDrugs.some((drug) => drug.id === selected.value)
        if (alreadyAdded) {
            setIsDrugExist(true)
            return
        }
        const newDrug = { value: selected.label, id: selected.value }
        setSelectedDrugs([...selectedDrugs, newDrug])
        // if (selected) {
        //   getDrugInstructions(selected.value);
        // }
    };

    const removeFilter = (drug) => {
        const filteredDrugs = selectedDrugs.filter((d) => d.id !== drug.id)
        setSelectedDrugs([...filteredDrugs])
    }

    const handleSaveModal = () => {
        const updatedFilters = selectedDrugs.map((ele) => ({ ...ele, category: "Drug" }))
        handleClose(updatedFilters)
    }

    return (
        <>
            <Modal
                show={showModal}
                onHide={handleClose}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Medicine
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="suggetion-box-enlarge d-block">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <div className="filter-container drug-search-box m-0"> */}
                            <div className="m-0">

                                {isDrugExist && (
                                    <div style={{ color: "red" }}>
                                        <p>This drug already added.</p>
                                    </div>
                                )}
                                <div className="row self-mx-0">
                                    <Select
                                        id="txtsearchmedicine"
                                        options={options}
                                        onInputChange={(inputValue) => {
                                            drugSearch(inputValue);
                                        }}
                                        onChange={handleSelectChange}
                                        placeholder="Search Medicine"
                                        isClearable
                                        isSearchable
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="selected-filters self-mt-0 d-flex self-flex-wrap col-gap-5">
                                {selectedDrugs.map((obj, index) => (
                                    <span key={index} className="filter-badge self-mx-7 self-m-10">
                                        {obj?.value}
                                        <span className="remove-filter" onClick={() => removeFilter(obj)}> × </span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSaveModal}>Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DrugFilterModal